import React, { FC } from "react";

import styles from "./styles.module.scss";

type Props = {
  show: boolean;
  isSelected: boolean;
};

const Separator: FC<Props> = ({ show, isSelected }) => {
  return (
    <div className={styles.separatorWrapper}>
      {show && (
        <div
          className={`${styles.separator} ${
            isSelected && styles.selectedSeparator
          }`}
        />
      )}
    </div>
  );
};

export default Separator;
